import api from "../../infra/api";

class SolicitacaoVistoriaArquivamento {
    async RecuperarArquivamento (id) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoVistoriaArquivamento?page=1&start=0&limit=25&filter=[{"property":"CodigoSolicitacaoVistoria","operator":"equal","value":"${id}","and":true}]`
        });

        return response.data;
    }
}

export default new SolicitacaoVistoriaArquivamento;